export const GET_CART_ITEMS_SUCCESS = "GET_CART_ITEMS_SUCCESS";
export const GET_CART_ITEMS = "GET_CART_ITEMS";

export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART = "ADD_TO_CART"

export const DELETE_CART_ITEM_SUCCESS = "DELETE_CART_ITEM_SUCCESS";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM"

export const GET_CART_ITEMS_COUNT_SUCCESS = "GET_CART_ITEMS_COUNT_SUCCESS";
export const GET_CART_ITEMS_COUNT = "GET_CART_ITEMS_COUNT";

export const SET_CART_ITEMS_COUNT = "SET_CART_ITEMS_COUNT";

export const EDIT_CART_ITEM_SUCCESS = "EDIT_CART_ITEM_SUCCESS";
export const EDIT_CART_ITEM = "EDIT_CART_ITEM"

export const PLACE_ORDER_SUCCESS = "PLACE_ORDER_SUCCESS";
export const PLACE_ORDER = "PLACE_ORDER";

export const GENERATE_OTP_SUCCESS = "GENERATE_OTP_SUCCESS";
export const GENERATE_OTP = "GENERATE_OTP";

export const PAYMENT_OPEN_FLOW_GEN_OTP_SUCCESS = "PAYMENT_OPEN_FLOW_GEN_OTP_SUCCESS"
export const PAYMENT_OPEN_FLOW_GEN_OTP = "PAYMENT_OPEN_FLOW_GEN_OTP"

export const VALIDATE_OTP_SUCCESS = "VALIDATE_OTP_SUCCESS";
export const VALIDATE_OTP = "VALIDATE_OTP"

export const PAYMENT_OPEN_FLOW_VALIDATE_OTP_SUCCESS = "PAYEMNT_OPEN_FLOW_VALIDATE_OTP_SUCCESS"
export const PAYMENT_OPEN_FLOW_VALIDATE_OTP = "PAYEMNT_OPEN_FLOW_VALIDATE_OTP"

export const RESEND_OTP_SUCCESS = "RESEND_OTP_SUCCESS"
export const RESEND_OTP = "RESEND_OTP"

export const PAYMENT_OPEN_FLOW_RESEND_OTP_SUCCESS = "PAYMENT_OPEN_FLOW_RESEND_OTP_SUCCESS"
export const PAYMENT_OPEN_FLOW_RESEND_OTP = "PAYMENT_OPEN_FLOW_RESEND_OTP"

export const GET_ORDER_PREVIEW_SUCCESS = "GET_ORDER_PREVIEW_SUCCESS"
export const GET_ORDER_PREVIEW = "GET_ORDER_PREVIEW"

export const ORDER_PREVIEW_OPEN_FLOW_SUCCESS = "ORDER_PREVIEW_OPEN_FLOW_SUCCESS"
export const ORDER_PREVIEW_OPEN_FLOW = "ORDER_PREVIEW_OPEN_FLOW"


export const INITIATE_PAYMENT_SUCCESS = "INITIATE_PAYMENT_SUCCESS"
export const INITIATE_PAYMENT = "INITIATE_PAYMENT"

export interface GetCartItemsRequestBody {
    clientCode: string;
    category: string;
    portfolioId: string
}

interface FundDetails {
    id: number;
    clientCode: string | null;
    schemeId: string | null;
    schemeImg: string | null;
    schemeName: string | null;
    categoryName: string | null;
    subCategoryName: string | null;
    year3Returns: string | null;
    riskType: string | null;
    trType: string | null;
    aumAmount: string | null;
    navDate: string | null;
    navValue: string | null;
    amount: string | null;
    folioNo: string | null;
    freeUnits?: number | null;
    investedValue: string | null;
    marketValue: string | null;
    exitLoad: string | null;
    accountType: string | null;
    frequency: string | null;
    noOfInstallment: string | null;
    sipDate: string | null;
    toSchemeId: string | null;
    toSchemeImg: string | null;
    toSchemeName: string | null;
    toCategoryName: string | null;
    toRiskType: string | null;
    toSubCategoryName: string | null;
    bankName: string | null;
    bankAccountNumber: string | null;
    mandateId: string | null;
    mandatesDisplayText: string | null;
    isRecommended: boolean;
    isOrderPlaced: boolean;
    isEdited: boolean;
    isDeleted: boolean;
    balanceUnits: string | null;
    balanceAmount: string | null;
    createdAt: Date;
    updatedAt: Date;
    transMode?: 'A' | 'U';
    units?: number | null;
    bankDetails: string | null;
    amcId?: string
    recommedationId: number | null
    allUnitsFlag?: "P" | "F" | null
    endDate?: string | null;
    isDividendReinvestment?: string;
    mPowerScheme?: string;
    firstOrderFlag?: string;
    isinCode?: string;
    mandate_payload: {
        [key: string]: string
    }
}

export interface GetCartItemsResponseBody {
    recommendations: FundDetails[];
    diy: FundDetails[];
    count: {
        newPurchase: number;
        additionalPurchase: number;
        swp: number;
        stp: number;
        redemption: number;
        switch: number;
    }
}

export interface AddToCartRequestData {
    aumAmount: string;
    isDividendReinvestment?: string;
    mPowerScheme?: string;
    trType: string;
    categoryName: string;
    clientCode: string;
    exitLoad: string;
    navValue: string;
    frequency: string;
    amount: number | string;
    riskType: string;
    schemeId: string;
    schemeName: string;
    subCategoryName: string;
    y3Returns: string;
    noOfInstallment: number | string;
    mandateId: string;
    sipDate: string;
    navDate: string;
    investedValue: string;
    marketValue: string;
    folioNo: string;
    toSchemeName: string;
    toCategoryName: string;
    toRiskType: string;
    toSubCategoryName: string;
    isRecommended: boolean;
    recommedationId?: number
    portfolioId?: string
    transMode?: string
    units?: string
    bankName?: string
    bankAccountNumber?: string
    toSchemeId?: string
    allUnitsFlag?: string
    amcId: string,
    rmId: string,
    endDate?: string,
    firstOrderFlag?: string
    mandate_payload?: {
        [key: string]: string
    }
}

export type AddToCartRequestBody = AddToCartRequestData[];

interface AddToCartResponseData {
    schemeName: string;
    isSuccess: boolean;
    message: string;
}

export interface AddToCartResponseBody {
    isSuccess: boolean,
    message: string,
    response: Array<AddToCartResponseData>
}

export interface DeleteCartItemRequestBody {
    clientCode: string;
    cartIds: string[];
    category: string;
    portfolioId: string
}

export type DeleteCartItemResponseBody = GetCartItemsResponseBody

export interface GetCartItemsCountRequestBody {
    clientCode: string;
    portfolioId: string;
}

export interface GetCartItemsCountResponseBody {
    isSuccess: boolean;
    cartItemsCount: number;
}

export interface EditCartItemRequestBody {
    clientCode: string;
    cartId: number | string;
    amount: number | string;
    frequency: string;
    noOfInstallment: number | string;
    sipDate: string;
    mandateId: number | string;
    category: string;
    trType: string;
    portfolioId: string;
    allUnitsFlag?: string;
}

export interface EditCartItemResponseBody {
    isSuccess: boolean;
    message: string;
    cartItems: GetCartItemsResponseBody[]
}

export interface PlaceOrderRequestBody {
    accountType?: string | null;
    orderDetails: {
        trType: string;
        clientCode: string;
        fromScheme: string;
        schemeName: string;
        amount: number;
        mobile: string;
        isRecommended: boolean;
        isDiy: boolean;
        email: string;
        portfolioId: string;
        noOfInstallments: number | null;
        mandateId: string;
        noOfWithdrawls: number | null;
        frequency: string;
        units: number | null;
        subBrokerArn: string;
        bankAccountNumber: string;
        toScheme: string;
        noOfTransfers: number | null;
        cartId: number | null;
        toSchemeName: string;
        folio: string;
        subBrokerCode: string;
        EUIN: string;
        transactionStartDate: string;
        transactionEndDate: string;
        rmId: string;
        portfolioName?: string;
        firstOrderFlag?: string;
    }[]
}

export interface PlaceOrderResponseBody {
    isSuccess: boolean;
    ordersValidation: {
        isValid: boolean;
        message: string;
        schemeName: string;
        transactionNumber: string;
        trType: string;
    }[],
    status_responses: any[];
    isPaymentFlow: boolean;
    cartId: string;
    token: string;
    message: string;
    otp_response: {
        isSuccess: boolean;
        cancelOrder: boolean;
        id: number;
        token: string;
        maximum_attemps: string;
        failed_attempts: number;
        cartId: string;
        message: string;
    }
}

export interface GenerateOtpRequestBody {
    order_cart_id: string;
    token: string;
}

export interface GenerateOtpResponseBody {
    isSuccess: boolean;
    cancelOrder: boolean;
    id: string;
    token: string;
    maximum_attempts: string;
    failed_attempts: string;
    cartId: string;
    message: string;
}

export interface ValidateOtpRequestBody {
    otp: string;
    token: string;
    id: string;
    cartId: string;
}

export interface ValidateOtpResponseBody {
    isSuccess: boolean;
    cancelOrder: boolean;
    message: string;
    cartId: string;
    token: string;
    id: string;
    paymentRequired?: boolean;
    login_token?: string;
    orders: {
        id: number;
        cartId: string;
        transactionCode: string;
        transactionNumber: string;
        bseOrderId: null;
        clientCode: string;
        fromSchemeCode: string;
        fromSchemeName: string;
        toSchemeCode: null;
        toSchemeName: null;
        buySell: string;
        buySellType: string;
        amount: string;
        quantity: string;
        allRedeemFlag: string;
        folioNumber: null;
        euin: string;
        transactionType: string;
        startDate: null;
        endDate: null;
        frequency: null;
        firstOrderFlag: null;
        installmentAmount: null;
        noOfInstallments: null;
        noOfWithdrawls: null;
        regId: null;
        mandateId: null;
        installmentUnits: null;
        bankAccountNumber: null;
        bseOrderSubmit: boolean;
        bseOrderStatus: boolean;
        bseOrderPayload: string;
        bseOrderResponse: null;
        orderSubmitToEMP: boolean;
        orderStatusFromEMP: boolean;
        mPowerTransactionPayload: null;
        mPowerTransactionResponse: null;
        orderDate: string;
        paymentStatus: boolean;
        paymentConfirmedDate: null;
        fundHouseApprovalStatus: boolean;
        fundHouseApprovedDate: null;
        unitsAllocationStatus: boolean;
        unitsAllocationDate: null;
        unitsAllocated: null;
        paymentStatusResponse: null;
        orderStatusResponse: null;
        status: string;
        subBrokerCode: null;
        subBrokerARN: string;
        minRedeemFlag: boolean;
        DPTxn: null;
        bankName: null;
        DPC: null;
        remarks: null;
        mobileNo: string;
        emailId: string;
        ipAdd: null;
        KYCStatus: null;
        isPaymentFailed: boolean;
        isFundHouseApprovalFailed: boolean;
        isUnitsAllocationFailed: boolean;
        DIY: boolean;
        isRecommended: boolean;
        recommendationId: null;
        portfolioId: string;
        rmId: string;
        internalReferenceNumber: null;
        isRTAReceived: boolean;
        rtaReceivedDate: null;
        rtaResponse: null;
        isRTADataMatched: boolean;
        transactionMode: string;
        amcId: null;
        accountType: null;
        token: string;
        tokenExpiryDate: string;
        fromSchemeRTACode: null;
        toSchemeRTACode: null;
        schemeType: null;
        orderPlacedAt: string;
        orderPlacedBy: null;
        orderApprovedAt: null;
        orderApprovedBy: null;
        exchange: string;
        rmRemarks: null;
        approverRemarks: null;
        paymentApprovedAt: null;
        paymentApprovedBy: null;
        sentToChecker: string;
        sentToCheckerAt: null;
        orderStatus: string;
        orderPaymentStatus: null;
        paymentReferenceNumber: null;
        paymentInitiatedAt: null;
        paymentCompletedAt: null;
        paymentGateway: null;
        paymentMode: null;
        product: null;
        rejectedByChecker: string;
        orderRejectedAt: null;
        investorBank: null;
        investorBankAccountNumber: null;
        investorBankIFSC: null;
        settlementBank: null;
        settlementBankAccountNumber: null;
        settlementBankIFSC: null;
        corpId: null;
        aggrId: null;
        benfName: null;
        aggrName: null;
        corpUser: null;
        debitStatus: null;
        creditedStatus: null;
        creditedDate: null;
        paymentURN: null;
        paymentUTRNumber: null;
        paymentRemarks: null;
        lastPaymentStatusCheck: null;
        sentToMpowerAt: null;
        isOrderApproved: string;
        isPaymentApproved: string;
        isOrderCancelled: string;
        isPaymentCancelled: string;
        countryCode: string;
        countryNameAndCode: string;
        company: string;
        userId: null;
        orderPaymentPayload: null;
        createdAt: string;
        updatedAt: string;
    }[]
}

export interface ResendOtpRequestBody {
    cartId: string;
    id: string;
    token: string
}

export interface ResendOtpResponseBody {
    isSuccess: boolean;
    cancelOrder: boolean;
    id: number;
    token: string;
    maximum_attemps: number;
    failed_attempts: number;
    cartId: string;
    message: string;
}

export interface NeftDetailsType {
    [key: string]: string
}

export interface GetOrderPreviewResponseBody {
    isSuccess: boolean;
    message: string;
    orders: {
        id: number;
        cartId: string;
        transactionCode: string;
        transactionNumber: string;
        bseOrderId: null;
        clientCode: string;
        fromSchemeCode: string;
        fromSchemeName: string;
        toSchemeCode: null;
        toSchemeName: null;
        buySell: string;
        buySellType: string;
        amount: string;
        quantity: string;
        allRedeemFlag: string;
        folioNumber: null;
        euin: string;
        transactionType: string;
        startDate: null;
        endDate: null;
        frequency: null;
        firstOrderFlag: null;
        installmentAmount: null;
        noOfInstallments: null;
        noOfWithdrawls: null;
        regId: null;
        mandateId: null;
        installmentUnits: null;
        bankAccountNumber: null;
        bseOrderSubmit: boolean;
        bseOrderStatus: boolean;
        bseOrderPayload: string;
        bseOrderResponse: null;
        orderSubmitToEMP: boolean;
        orderStatusFromEMP: boolean;
        mPowerTransactionPayload: null;
        mPowerTransactionResponse: null;
        orderDate: string;
        paymentStatus: boolean;
        paymentConfirmedDate: null;
        fundHouseApprovalStatus: boolean;
        fundHouseApprovedDate: null;
        unitsAllocationStatus: boolean;
        unitsAllocationDate: null;
        unitsAllocated: null;
        paymentStatusResponse: null;
        orderStatusResponse: null;
        status: null;
        subBrokerCode: null;
        subBrokerARN: string;
        minRedeemFlag: boolean;
        DPTxn: null;
        bankName: null;
        DPC: null;
        remarks: null;
        mobileNo: string;
        emailId: string;
        ipAdd: null;
        KYCStatus: null;
        isPaymentFailed: boolean;
        isFundHouseApprovalFailed: boolean;
        isUnitsAllocationFailed: boolean;
        DIY: boolean;
        isRecommended: boolean;
        recommendationId: null;
        portfolioId: string;
        rmId: string;
        internalReferenceNumber: null;
        isRTAReceived: boolean;
        rtaReceivedDate: null;
        rtaResponse: null;
        isRTADataMatched: boolean;
        transactionMode: string;
        amcId: string;
        accountType: null;
        token: string;
        tokenExpiryDate: string;
        fromSchemeRTACode: null;
        toSchemeRTACode: null;
        schemeType: null;
        orderPlacedAt: string;
        orderPlacedBy: null;
        orderApprovedAt: null;
        orderApprovedBy: null;
        exchange: string;
        rmRemarks: null;
        approverRemarks: null;
        paymentApprovedAt: null;
        paymentApprovedBy: null;
        sentToChecker: string;
        sentToCheckerAt: null;
        orderStatus: string;
        orderPaymentStatus: null;
        paymentReferenceNumber: null;
        paymentInitiatedAt: null;
        paymentCompletedAt: null;
        paymentGateway: null;
        paymentMode: null;
        product: null;
        rejectedByChecker: string;
        orderRejectedAt: null;
        investorBank: null;
        investorBankAccountNumber: null;
        investorBankIFSC: null;
        settlementBank: null;
        settlementBankAccountNumber: null;
        settlementBankIFSC: null;
        corpId: null;
        aggrId: null;
        benfName: null;
        aggrName: null;
        corpUser: null;
        debitStatus: null;
        creditedStatus: null;
        creditedDate: null;
        paymentURN: null;
        paymentUTRNumber: null;
        paymentRemarks: null;
        lastPaymentStatusCheck: null;
        sentToMpowerAt: null;
        isOrderApproved: string;
        isPaymentApproved: string;
        isOrderCancelled: string;
        isPaymentCancelled: string;
        countryCode: string;
        countryNameAndCode: string;
        company: string;
        userId: null;
        orderPaymentPayload: null;
        createdAt: string;
        updatedAt: string;
    }[];
    amount: number;
    paymentRequired: boolean;
    cartId: string;
    token: string;
    portfolioId?: string;
    payable_amount: number | null;
    transaction_amount: number | null;
    status?: string;
    neft_details?: NeftDetailsType[];
}

export interface OrderPreviewOpenFlowRes {
    isSuccess: boolean;
    message: string;
    amount: number;
    transaction_amount: number | null;
    payable_amount: number | null;
    paymentRequired: boolean;
    cartId: string;
    token: string;
    email: string;
    mobile: string;
    status: string;
    name: string;
    accountType: string;
    company: string;
    clientCode: string;
    portfolioId: string;
    orders: {
        id: number;
        cartId: string;
        transactionCode: string;
        transactionNumber: string;
        bseOrderId: null;
        clientCode: string;
        fromSchemeCode: string;
        fromSchemeName: string;
        toSchemeCode: null;
        toSchemeName: null;
        buySell: string;
        buySellType: string;
        amount: string;
        quantity: string;
        allRedeemFlag: string;
        folioNumber: null;
        euin: string;
        transactionType: string;
        startDate: null;
        endDate: null;
        frequency: null;
        firstOrderFlag: null;
        installmentAmount: null;
        noOfInstallments: null;
        noOfWithdrawls: null;
        regId: null;
        mandateId: null;
        installmentUnits: null;
        bankAccountNumber: null;
        bseOrderSubmit: boolean;
        bseOrderStatus: boolean;
        bseOrderPayload: string;
        bseOrderResponse: null;
        orderSubmitToEMP: boolean;
        orderStatusFromEMP: boolean;
        mPowerTransactionPayload: null;
        mPowerTransactionResponse: null;
        orderDate: string;
        paymentStatus: boolean;
        paymentConfirmedDate: null;
        fundHouseApprovalStatus: boolean;
        fundHouseApprovedDate: null;
        unitsAllocationStatus: boolean;
        unitsAllocationDate: null;
        unitsAllocated: null;
        paymentStatusResponse: null;
        orderStatusResponse: null;
        status: null;
        subBrokerCode: null;
        subBrokerARN: string;
        minRedeemFlag: boolean;
        DPTxn: null;
        bankName: null;
        DPC: null;
        remarks: null;
        mobileNo: string;
        emailId: string;
        ipAdd: null;
        KYCStatus: null;
        isPaymentFailed: boolean;
        isFundHouseApprovalFailed: boolean;
        isUnitsAllocationFailed: boolean;
        DIY: boolean;
        isRecommended: boolean;
        recommendationId: null;
        portfolioId: string;
        rmId: string;
        internalReferenceNumber: null;
        isRTAReceived: boolean;
        rtaReceivedDate: null;
        rtaResponse: null;
        isRTADataMatched: boolean;
        transactionMode: string;
        amcId: string;
        accountType: null;
        token: string;
        tokenExpiryDate: string;
        fromSchemeRTACode: null;
        toSchemeRTACode: null;
        schemeType: null;
        orderPlacedAt: string;
        orderPlacedBy: null;
        orderApprovedAt: null;
        orderApprovedBy: null;
        exchange: string;
        rmRemarks: null;
        approverRemarks: null;
        paymentApprovedAt: null;
        paymentApprovedBy: null;
        sentToChecker: string;
        sentToCheckerAt: null;
        orderStatus: string;
        orderPaymentStatus: null;
        paymentReferenceNumber: null;
        paymentInitiatedAt: null;
        paymentCompletedAt: null;
        paymentGateway: null;
        paymentMode: null;
        product: null;
        rejectedByChecker: string;
        orderRejectedAt: null;
        investorBank: null;
        investorBankAccountNumber: null;
        investorBankIFSC: null;
        settlementBank: null;
        settlementBankAccountNumber: null;
        settlementBankIFSC: null;
        corpId: null;
        aggrId: null;
        benfName: null;
        aggrName: null;
        corpUser: null;
        debitStatus: null;
        creditedStatus: null;
        creditedDate: null;
        paymentURN: null;
        paymentUTRNumber: null;
        paymentRemarks: null;
        lastPaymentStatusCheck: null;
        sentToMpowerAt: null;
        isOrderApproved: string;
        isPaymentApproved: string;
        isOrderCancelled: string;
        isPaymentCancelled: string;
        countryCode: string;
        countryNameAndCode: string;
        company: string;
        userId: null;
        orderPaymentPayload: null;
        createdAt: string;
        updatedAt: string;
    }[];
    currency_details: {
        result: {
            locale: string;
            currencyCode: string;
            currencySymbol: string;
        },
        message: string;
        isSuccess: boolean;
    },
}

export interface InitiatePaymentRequestBody {
    cartId: string;
    token: string;
    vpaid?: string;
    neftReferenceNumber?: string;
    paymentMode: string;
    accountNumber: string;
    bankName: string;
    ifsc: string;
    loopbackURL: string;
    accountType?: string;
}

export interface InitiatePaymentResponseBody {
    isSuccess: boolean;
    response: string;
    internalReferenceNumber: string;
    request_response: any;
}

